import { render, staticRenderFns } from "./DamageFields.vue?vue&type=template&id=8d4a3c4c&scoped=true"
import script from "./DamageFields.vue?vue&type=script&lang=js"
export * from "./DamageFields.vue?vue&type=script&lang=js"
import style0 from "./DamageFields.vue?vue&type=style&index=0&id=8d4a3c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4a3c4c",
  null
  
)

export default component.exports